/*
 * @Author: Teemo Ding
 * @Date: 2022-03-24 10:54:09
 * @LastEditTime: 2023-02-10 16:01:51
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/Components/Customer/BuyerInfo.tsx
 */
import React, { Fragment } from 'react';
import { get } from 'lodash';
import { useRequest } from 'ahooks';
import { Icon } from '@/src/tools/icon';
import { EnumFieldType } from 'src/components/FieldModal/config';
import { billingAddressPage, buyerPage } from '@/src/request/order/createOrder';
import {
  getBuyer,
  saveBuyer,
  getBillingAddress,
  saveBillingAddress,
} from 'src/request/order';
import CustomerInfoModal from 'src/pages/CustomerDatabaseConfig/Components/CustomerInfoModal';
import { nameTrans, addressFormat } from '@/src/tools/helper';
import BillingAddress from '../BillingAddress';
import ModalHoc from 'src/constrains/ModalHOC';
import { NEW } from 'src/tools/constant';
import {
  maskPhone,
  maskEmail,
  maskFullName,
  maskFullAdress,
} from 'src/tools/mask';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const BuyerInfo = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    modalOp: { setShowModal, setModalTitle, setModalContent, setWidth },
    disabled,
    customer,
    registered,
    customerDetail,
    reLoadOrderPage,
    salesChannelUuid,
    orderUuid,
    setBillingAddressDetail,
    billingAddressDetail,
    setBuyerInfo,
    buyerInfo,
    findCustomerFields,
    languageCode,
    changeCustomer,
    hideBillingAddress,
    hideBuyer,
    visible,
    //  handleApply,
  } = props;
  const {
    billingAddress,
    billingAddressLine1,
    billingAddressLine2,
    buyerEmail,
    buyerName,
    buyerFirstName,
    buyerLastName,
    buyerPhoneNo,
  } = customerDetail || {};
  //保存BillingAddress
  const { run: _saveBillingAddress } = useRequest(
    (data) => saveBillingAddress(orderUuid, data),
    {
      manual: true,
      onSuccess: () => {
        handleCancel();
        reLoadOrderPage();
      },
    },
  );

  //BillingAddress弹窗
  const { run: _getBillingAddress } = useRequest(
    () =>
      customer
        ? billingAddressPage({
            salesChannelUuid,
            customer,
            uuid: orderUuid === NEW ? '' : orderUuid,
          })
        : getBillingAddress(orderUuid),
    {
      manual: true,
      onSuccess: (res) => {
        const { destinations = [], consignee, countries = [] } = res;
        setShowModal(true);
        setModalTitle(
          `${getI18n('general.edit')} ${getI18n('general.billingAddress')}`,
        );
        setWidth(600);
        setModalContent(
          <BillingAddress
            orderUuid={orderUuid}
            destinations={destinations}
            consignee={billingAddressDetail || consignee}
            countries={countries}
            languageCode={languageCode}
            onCancel={handleCancel}
            reLoadOrderPage={reLoadOrderPage}
            onConfirm={(e) => {
              const cb = (obj) => {
                handleCancel();
                if (reLoadOrderPage) reLoadOrderPage();
              };
              const cbCreate = (data) => {
                setBillingAddressDetail(data);
                const formatsIndex = destinations.filter(
                  (o) => o.country.code == data.countryVO.code,
                );
                changeCustomer({
                  billingAddress: addressFormat(
                    formatsIndex[0].format.fields,
                    data,
                  ),
                });
                setBuyerInfo({ ...buyerInfo, consignee: data });
                handleCancel();
              };

              if (customer) {
                return new Promise((resolve, reject) => {
                  resolve({
                    response: { status: 200, data: { payload: e } },
                    cb: cbCreate,
                  });
                });
              } else {
                return _saveBillingAddress(e).then((res) => {
                  return { response: res, cb };
                });
              }
            }}
          />,
        );
      },
    },
  );
  //BuyerInfo弹窗
  const { run: _getBuyer } = useRequest(
    (data) =>
      customer
        ? buyerPage({
            salesChannelUuid,
            customer,
            uuid: orderUuid === NEW ? '' : orderUuid,
          })
        : getBuyer(orderUuid),
    {
      manual: true,
      onSuccess: (res) => {
        const {
          customerInfoFields,
          consignee,
          areaCodes,
          fullNameAutoPopulate,
        } = res;
        const areaCodesCover = areaCodes.map((item) => ({
          label: `+ ${item.areaCode}`,
          value: item.areaCode,
        }));
        const customerInfoFieldsCover = (
          (buyerInfo || {}).customerInfoFields ||
          customerInfoFields ||
          []
        ).map((item) => {
          if (
            get(item, 'field.fieldType') == EnumFieldType.MobileNumber ||
            get(item, 'field.fieldType') == EnumFieldType.AreaCodeMobileNumber
          ) {
            item.field.fieldType = EnumFieldType.AreaCodeMobileNumber;
            item.field.selectorOptions = areaCodesCover;
          }
          return item;
        });
        setShowModal(true);
        setModalTitle(
          `${getI18n('general.edit')} ${getI18n(
            'allOrders.orderDetail.buyerinfo',
          )} ${
            !customer
              ? registered
                ? `(${getI18n('allOrders.orderDetail.registered')})`
                : `(${getI18n('allOrders.orderDetail.guest')})`
              : ''
          }`,
        );
        setWidth(600);
        setModalContent(
          <CustomerInfoModal
            onCancel={handleCancel}
            fields={customerInfoFieldsCover}
            onConfirm={(e) => {
              const cb = (obj) => {
                handleCancel();
                if (reLoadOrderPage) reLoadOrderPage();
              };
              const cbCreat = (data) => {
                const {
                  buyerInfoData,
                  firstName,
                  lastName,
                  fullName,
                  buyerEmail,
                  buyerPhoneNo,
                } = findCustomerFields(
                  data,
                  customerInfoFields,
                  'uuid',
                  'fieldType',
                  'value',
                );
                setBuyerInfo({
                  ...buyerInfo,
                  customerInfoFields: buyerInfoData,
                });
                changeCustomer({
                  buyerName: nameTrans(
                    fullNameAutoPopulate,
                    firstName,
                    lastName,
                    fullName,
                  ),
                  buyerEmail,
                  buyerPhoneNo,
                });

                handleCancel();
              };
              const obj = {
                customerInfoFields: e,
                consignee,
              };
              if (customer) {
                return new Promise((resolve, reject) => {
                  resolve({
                    response: { status: 200, data: { payload: e } },
                    cb: cbCreat,
                  });
                });
              } else {
                return saveBuyer(orderUuid, obj).then((res) => {
                  return { response: res, cb };
                });
              }
            }}
          />,
        );
      },
    },
  );
  const handleCancel = () => {
    setShowModal(false);
  };

  return (
    <Fragment>
      {!hideBuyer && (
        <div className={css.customItem}>
          <h3>
            {getI18n('allOrders.orderDetail.buyerinfo')}{' '}
            {disabled ? (
              <Icon className={css.disable} type='iconedit' />
            ) : (
              <Icon onClick={_getBuyer} type='iconedit' />
            )}
          </h3>
          <div>
            <span className={css.buyerName}>
              {visible
                ? buyerName
                : maskFullName(buyerLastName, buyerFirstName, buyerName)}
            </span>
            {!customer
              ? registered
                ? `(${getI18n('allOrders.orderDetail.registered')})`
                : `(${getI18n('allOrders.orderDetail.guest')})`
              : null}
          </div>
          <span>{visible ? buyerEmail : maskEmail(buyerEmail)}</span>
          <span>{visible ? buyerPhoneNo : maskPhone(buyerPhoneNo, true)}</span>
        </div>
      )}
      {!hideBillingAddress && (
        <div className={css.customItem}>
          <h3>
            {getI18n('general.billingAddress')}

            {disabled ? (
              <Icon className={css.disable} type='iconedit' />
            ) : (
              <Icon onClick={_getBillingAddress} type='iconedit' />
            )}
          </h3>
          {visible
            ? billingAddress
            : maskFullAdress(
                billingAddressLine1,
                billingAddressLine2,
                billingAddress,
              )}
        </div>
      )}
      {!hideBillingAddress && !hideBuyer && (
        <div className={css.splitLine}></div>
      )}
    </Fragment>
  );
};

export default ModalHoc(BuyerInfo);
